/**
 * A strict cmdk `filter` for `SearchableSelect` pickers whose options carry a
 * long search haystack in `keywords` (e.g. PersonSelect's `search_text`).
 *
 * cmdk's default filter is a fuzzy subsequence match: over a ~100-character
 * haystack almost every row contains the typed letters in order ("adam"
 * matches "amsterdam"), so nothing is ever hidden. Here every whitespace
 * token must instead appear as a contiguous, case-insensitive substring of the
 * label or a keyword. Hits on the label outrank keyword-only hits.
 *
 * Unlike cmdk's default, this returns 0 for SearchableSelect's synthetic
 * "Create new" / custom-value rows once the user types (their text rarely
 * contains the search), so those rows hide while searching; creation is then
 * reached through the empty-state button when nothing matches.
 */
export function substringSearchFilter(label: string, search: string, keywords: string[] = []): number {
  const s = search.trim().toLowerCase();
  if (!s) return 1;
  const l = label.toLowerCase();
  const haystack = [l, ...keywords.map((k) => k.toLowerCase())].join(" ");
  if (!s.split(/\s+/).every((token) => haystack.includes(token))) return 0;
  if (l === s) return 10;
  if (l.startsWith(s)) return 8;
  if (l.includes(s)) return 6;
  return 3; // keyword-only or multi-token hit
}
